import {SelectedCarrierServiceOption} from '@wix/auto_sdk_ecom_current-cart';

export type SelectedCarrierServiceOptionWithPrivateFields = SelectedCarrierServiceOption & {
  logistics?: {deliveryTimeSlot?: {from: string; to: string}};
};

export class SelectedCarrierServiceOptionModel {
  public code: string;
  public pickupMethod: string;
  public hasTimeSlots: boolean;
  public isPickup: boolean;

  constructor(params: SelectedCarrierServiceOptionModel) {
    this.code = params.code;
    this.pickupMethod = params.pickupMethod;
    this.hasTimeSlots = params.hasTimeSlots;
    this.isPickup = params.isPickup;
  }

  public static fromSDK(option: SelectedCarrierServiceOptionWithPrivateFields): SelectedCarrierServiceOptionModel {
    return new SelectedCarrierServiceOptionModel({
      code: option?.code,
      pickupMethod: option?.logistics?.pickupDetails?.pickupMethod,
      hasTimeSlots: !!option?.logistics?.deliveryTimeSlot,
      isPickup: !!option?.logistics?.pickupDetails?.pickupMethod,
    });
  }
}
